import React from "react";
import { chunk } from "lodash/fp";
import type { Designer as DesignerType } from "storefront/Designer";
import Designer from "./designer";

type Props = {
  designers: Map<string, Array<DesignerType>>;
};

const renderGroup = (
  key: string,
  group: Array<DesignerType>,
  index: number,
) => (
  <div className="designer-group" key={`${key}-${index}`}>
    {group.map((d) => (
      <Designer designer={d} key={d.name} />
    ))}
  </div>
);

const renderDropCapGroup = (key: string, group: Array<DesignerType>) => (
  <div
    id={`anchor-${key === "#" ? "pound" : key}`}
    className="drop-cap-group"
    key={key}
  >
    <div className="drop-cap">{key}</div>
    <div className="designers">
      {chunk(Math.ceil(group.length / 3), group).map((g, index) =>
        renderGroup(key, g, index),
      )}
    </div>
  </div>
);

const DropCapList = ({ designers }: Props) => (
  <div className="designer-list drop-cap-list-wrapper">
    {designers.size === 0 ? (
      <p>No Designers Found</p>
    ) : (
      [...designers].map(([key, group]) => renderDropCapGroup(key, group))
    )}
  </div>
);

export default DropCapList;
